import { createSelector } from 'reselect';
var _hasPermission = function hasPermission(permissions, permission) {
  return permissions[permission] == true;
};
var getAllPermissions = function getAllPermissions(state) {
  var auth = state.auth;
  var permissionsList = {};
  var permissions = {
    hasPermission: function hasPermission(permission) {
      return _hasPermission(permissionsList, permission);
    },
    hasOneOfPermissions: function hasOneOfPermissions(permissions) {
      return permissions.reduce(function (prev, cur) {
        return prev || _hasPermission(permissionsList, cur);
      }, false);
    },
    hasAllPermissions: function hasAllPermissions(permissions) {
      return permissions.reduce(function (prev, cur) {
        return prev && _hasPermission(permissionsList, cur);
      }, true);
    }
  };
  if (auth.facilityUser == null) {
    return permissions;
  }
  permissionsList = auth.facilityUser.roles.map(function (r) {
    var permissions = r.permissions;
    // Remove any "false" permissions to avoid them potentially overwriting roles with "true" permissions
    for (var k in permissions) {
      if (permissions[k] == false) {
        delete permissions[k];
      }
    }
    return permissions;
  }).reduce(function (prev, cur) {
    return Object.assign({}, prev, cur);
  }, {});
  // Temporary hack until everything is converted to React
  window.permissions = permissions;
  return permissions;
};
export var getPermissions = createSelector([getAllPermissions], function (allPermissions) {
  return allPermissions;
});